import {
    apiRequest,
    presensiList,
} from "../../../../services/adapters/kepegawaian/presensiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", presensiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository